<div class="p6-sync-results-modal">
  <!-- Modal Header -->
  <div class="modal-header">
    <h2 mat-dialog-title class="modal-title">
      <mat-icon class="title-icon" svgIcon="show_chart"></mat-icon>
      {{ 'integration.p6_sync_results' | transloco }}
    </h2>
    <button
      mat-icon-button
      class="close-button"
      (click)="onClose()"
      [attr.aria-label]="'Close dialog'"
    >
      <mat-icon svgIcon="close"></mat-icon>
    </button>
  </div>

  <!-- Modal Content -->
  <div mat-dialog-content class="modal-content">
    <!-- Success Results -->
    <div *ngIf="isSuccessful()" class="success-results">
      <!-- Success Alert -->
      <div class="alert alert-success">
        <mat-icon class="alert-icon" svgIcon="check_circle"></mat-icon>
        <div class="alert-content">
          <h4>{{ 'integration.p6_sync_successful' | transloco }}</h4>
          <p>{{ 'integration.p6_sync_completed_successfully' | transloco }}</p>
        </div>
      </div>

      <!-- Statistics Grid -->
      <div class="stats-grid">
        <div class="stat-card created">
          <div class="stat-number">{{ syncResult.created_count }}</div>
          <div class="stat-label">{{ 'integration.p6_reports_created' | transloco }}</div>
        </div>

        <div class="stat-card updated">
          <div class="stat-number">{{ syncResult.updated_count }}</div>
          <div class="stat-label">{{ 'integration.p6_reports_updated' | transloco }}</div>
        </div>

        <div class="stat-card failed">
          <div class="stat-number">{{ syncResult.failed_count }}</div>
          <div class="stat-label">{{ 'integration.p6_reports_failed' | transloco }}</div>
        </div>
      </div>

      <!-- Success Rate -->
      <div class="success-rate">
        <mat-progress-bar
          mode="determinate"
          [value]="getSuccessRate()"
          color="primary"
        ></mat-progress-bar>
        <span class="rate-text"
          >{{ getSuccessRate() }}% {{ 'integration.success_rate' | transloco }}</span
        >
      </div>

      <!-- Failed Reports Section -->
      <div *ngIf="hasFailedReports()" class="failed-reports-section">
        <h5 class="failed-reports-title">
          <mat-icon class="warning-icon" svgIcon="warning"></mat-icon>
          {{ 'integration.failed_p6_reports' | transloco }}
        </h5>

        <div class="failed-reports-list">
          <div *ngFor="let report of syncResult.failed_p6_reports" class="failed-report-item">
            <div class="report-header">
              <strong>{{ report.report_name }}</strong>
              <span *ngIf="report.project_id" class="project-id">({{ report.project_id }})</span>
            </div>
            <div class="report-reason">{{ report.reason }}</div>
          </div>
        </div>
      </div>
    </div>

    <!-- Error Results -->
    <div *ngIf="!isSuccessful()" class="error-results">
      <div class="alert alert-error">
        <mat-icon class="alert-icon" svgIcon="error"></mat-icon>
        <div class="alert-content">
          <h4>{{ 'integration.p6_sync_failed' | transloco }}</h4>
          <p>{{ syncResult.message || ('integration.p6_sync_failed_message' | transloco) }}</p>
        </div>
      </div>
    </div>
  </div>

  <!-- Modal Actions -->
  <div mat-dialog-actions class="modal-actions">
    <button mat-button class="cancel-button" (click)="onClose()">
      {{ 'common.close' | transloco }}
    </button>
    <button
      mat-raised-button
      color="primary"
      class="refresh-button"
      *ngIf="isSuccessful()"
      (click)="onRefreshP6Data()"
    >
      <mat-icon svgIcon="refresh"></mat-icon>
      {{ 'integration.refresh_p6_data' | transloco }}
    </button>
  </div>
</div>
